import React, { ReactElement } from 'react';

import classNames from 'classnames';

import { AVATAR_WITH_TEXT_CLASS } from '../../../../utils/constants';
import Avatar from '../../Avatar';
import * as Styled from './AvatarWithText.styles';
import { IAvatarWithTextProps } from './AvatarWithText.types';

const AvatarWithText = ({
  className = '',
  src = '',
  title = '',
  description = '',
  abbreviation = '',
  size = 'medium',
  ...rest
}: IAvatarWithTextProps): ReactElement => (
  <Styled.AvatarWithText className={classNames(AVATAR_WITH_TEXT_CLASS, className)} {...rest}>
    <Avatar src={src} abbreviation={abbreviation} size={size} />
    <Styled.Label>
      {title && (
        <Styled.Title size={size} description={description}>
          {title}
        </Styled.Title>
      )}
      {description && <Styled.Description size={size}>{description}</Styled.Description>}
    </Styled.Label>
  </Styled.AvatarWithText>
);

export default AvatarWithText;
